import { useContext } from 'react';
import { NavigationComponentsContext } from '../components/internal/NavigationComponentsContext';
export const useNavComponentsManager = () => {
  const manager = useContext(NavigationComponentsContext);
  if (!manager) {
    throw new Error('Navigation components manager not found. Is your component wrapped in `NavigationComponents`?');
  }
  return manager;
};